import { toJpeg } from 'html-to-image';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import { CustomModal } from '../../components/form/modal';
import Select from '../../components/form/select';
import { Loader } from '../../components/utilities/loader';
import { getEditedTemplateCode } from '../../store/template/templateService';

import './editTemplate.css';

const fontStyle = [
    { class: "italic", name: 'Italic', btn: 'primary ' },
    { class: "bold", name: "Bold", btn: "primary" },
    { class: "underline", name: "Underline", btn: "primary" },
    { class: "normal", name: "Normal", btn: "primary" },
]

const fontFamily = [
    { name: "Lato", key: "lato" },
    { name: "Fantasy", key: "fantasy" },
    { name: "Sans Serif", key: "sans-serif" },
    { name: "Cursive", key: "cursive" }
];

const removeFamily = ["lato", "sans-serif", "serif", "fantasy", "cursive"];

const removeColor = [
    { class: "red", name: "RED", btn: 'primary' },
    { class: "black", name: "BLACK", btn: "primary" },
    { class: "white", name: "WHITE", btn: "primary" },
]
const colors = ["red", "black", "white"];

const idNames = {
    'p-title': "Title",
    'p-description': "Description",
    'p-qr': "QR",
    'p-new-price': "New Price",
    'p-quantity': "Quantity",
    'p-head': "Header Background",
    'p-card-border': "Body Background",
    'p-body': "Body Background",
    'p-old-price': "Old Price",
    'p-discount': "Discount",
    'p-$': "Doller"
}

const isBG = {
    'p-head': "Header Background",
    'p-card-border': "Body Background",
    'p-body': "Body Background",
}

const imgClasses = {
    '2.13': {
        size: { width: 250, height: 120 },
        1: {
            title: "title1 card-bold", des: "description1 ", oldprice: "prev-cost card-bold", newprice: "card-bold p-cost",
            dollar: "dollar card-bold ", quantity: "quantity1", headBg: "c-title", bodyBg: "card-border1", decimal: 'price-decimal1 bold', discount: "p-text"
        },
        2: {
            title: "title2 card-bold", des: "description2 ", oldprice: "prev-cost card-bold", newprice: "card-bold p-cost",
            dollar: "dollar card-bold ", quantity: "quantity2", headBg: "c-title", bodyBg: "c-body", decimal: 'price-decimal2 bold', discount: "p-text"
        }
    },
    '2.66': {
        size: { width: 296, height: 152 },
        1: {
            title: "title1-296 card-bold", des: "description1-296 ", oldprice: "prev-cost card-bold", newprice: "card-bold p-cost2-296",
            dollar: "dollar card-bold", quantity: "quantity1-296", headBg: "c-title", bodyBg: "c-body", decimal: 'price-decimal1-296 bold', discount: "p-text"
        },
        2: {
            title: "title2-296 card-bold", des: "description2-296 ", oldprice: "prev-cost card-bold", newprice: "card-bold p-cost2-296",
            dollar: "dollar card-bold", quantity: "quantity2-296", headBg: "c-title", bodyBg: "card-border2-296", decimal: 'price-decimal2-296 bold', discount: "p-text"
        },
    },
    '4.2': {
        size: { width: 400, height: 300 },
        1: {
            title: "title1-400 card-bold", des: "description1-400 ", oldprice: "prev-cost card-bold", newprice: "card-bold p-cost1-400",
            dollar: "dollar2-296 card-bold", quantity: "quantity1-400", headBg: "c-title", bodyBg: "card-box1-400", decimal: 'price-decimal1-400 bold', discount: "p-text"
        },
        2: {
            title: "title2-400 card-bold", des: "description2-400 ", oldprice: "prev-cost card-bold", newprice: "card-bold p-cost2-400",
            dollar: "dollar2-400 card-bold", quantity: "quantity2-400", headBg: "c-title2-400", bodyBg: "card-border2-400", decimal: 'price-decimal2-400 bold', discount: "p-text"
        }
    },
    // '1.54': {
    //     size: { width: 200, height: 200 },
    //     1: { title: "title2 card-bold", des: "description2 ", oldprice: "prev-cost card-bold", newprice: "card-bold p-cost", dollar: "dollar card-bold", quantity: "quantity1", headBg: "c-title", bodyBg: "card-box1", decimal: 'price-decimal1 bold', discount: "p-text" },
    //     2: { title: "title2 card-bold", des: "description2 ", oldprice: "prev-cost card-bold", newprice: "card-bold p-cost", dollar: "dollar card-bold", quantity: "quantity2", headBg: "c-title", bodyBg: "c-body", decimal: 'price-decimal1 bold', discount: "p-text" }
    // },
    // '2.9': {
    //     size: { width: 296, height: 128 },
    //     1: { title: "title2 card-bold", des: "description2 ", oldprice: "prev-cost card-bold", newprice: "card-bold p-cost", dollar: "dollar card-bold", quantity: "quantity1", headBg: "c-title", bodyBg: "card-box1", decimal: 'price-decimal1 bold', discount: "p-text" },
    //     2: { title: "title2 card-bold", des: "description2 ", oldprice: "prev-cost card-bold", newprice: "card-bold p-cost", dollar: "dollar card-bold", quantity: "quantity2", headBg: "c-title", bodyBg: "c-body", decimal: 'price-decimal1 bold', discount: "p-text" }
    // },
    // '7.5': {
    //     size: { width: 800, height: 480 },
    //     1: { title: "title2 card-bold", des: "description2 ", oldprice: "prev-cost card-bold", newprice: "card-bold p-cost", dollar: "dollar card-bold", quantity: "quantity1", headBg: "c-title", bodyBg: "card-box1", decimal: 'price-decimal1 bold', discount: "p-text" },
    //     2: { title: "title2 card-bold", des: "description2 ", oldprice: "prev-cost card-bold", newprice: "card-bold p-cost", dollar: "dollar card-bold", quantity: "quantity2", headBg: "c-title", bodyBg: "c-body", decimal: 'price-decimal1 bold', discount: "p-text" }
    // },
}

export default function EditTemplate() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams();

    const [state, setState] = useState({ htmlCode: '' });
    const [value, setValue] = useState({ viewPassword: false, isUpdate: false, storeList: [], sizeList: [] });
    const [editData, setHtml] = useState()
    const [lastSelected, setFontFamily] = useState('lato');
    const [selected, setFamily] = useState({ title: "", doller: "", price: "", quantity: "", description: "" });
    const [color, setColor] = useState({ bc: "", hc: "" });
    const [isPoli, setPoli] = useState(false)
    const [tempSize, setTempSize] = useState("")
    const [model, setmodel] = useState(false)
    const [isLoad, setLoad] = useState(false)
    const [selectID, setSelectID] = useState("");
    const { templateData } = useSelector(state => state.templates);
    const [className, setClassName] = useState({})
    const [normal, setNormal] = useState({})

    const templateValues2 = {
        title: "Sample Test Product for Canyon Tech",
        description: " Descrip Base64 to image online using a free decoding tool which allows you to decode Base64 as image and preview it directly in the browser. In addition",
        newprice: "2402 ",
        oldprice: "300",
        quantity: '1 per kg',
        phone: "",
        stock: "",
        qrlink: "data:image/png;base64,/9j/4AAQSkZJRgABAgAAAQABAAD/2wBDAAgGBgcGBQgHBwcJCQgKDBQNDAsLDBkSEw8UHRofHh0aHBwgJC4nICIsIxwcKDcpLDAxNDQ0Hyc5PTgyPC4zNDL/2wBDAQkJCQwLDBgNDRgyIRwhMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjL/wAARCAAyAMYDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD3+iiigD5//aa/5lb/ALe//aNegeEv+SvfEX/uGf8ApO1ef/tNf8yt/wBvf/tGvQPCX/JXviL/ANwz/wBJ2oAPgl/ySHQv+3j/ANKJK8//AObvP8/8+FegfBL/AJJDoX/bx/6USV5//wA3ef5/58KAOA+Nv/JXtd/7d/8A0njr3/xb/wAle+HX/cT/APSda8A+Nv8AyV7Xf+3f/wBJ469/8W/8le+HX/cT/wDSdaAPP/2Zf+Zp/wC3T/2tR/zaH/n/AJ/6P2Zf+Zp/7dP/AGtR/wA2h/5/5/6AOA8Jf8kh+Iv/AHDP/Shq7/8Aaa/5lb/t7/8AaNcB4S/5JD8Rf+4Z/wClDV3/AO01/wAyt/29/wDtGgA/5tD/AM/8/wDXAeLf+SQ/Dr/uJ/8ApQtd/wD82h/5/wCf+uA8W/8AJIfh1/3E/wD0oWgD3/xb/wAle+HX/cT/APSda8A+Nv8AyV7Xf+3f/wBJ469/8W/8le+HX/cT/wDSda8A+Nv/ACV7Xf8At3/9J46AD42/8le13/t3/wDSeOu//wCbQ/8AP/P/AFwHxt/5K9rv/bv/AOk8dd//AM2h/wCf+f8AoA9A8Jf8le+Iv/cM/wDSdq8//Zl/5mn/ALdP/a1egeEv+SvfEX/uGf8ApO1ef/sy/wDM0/8Abp/7WoA4D42/8le13/t3/wDSeOu/+IH/ADWL/uC/+y1wHxt/5K9rv/bv/wCk8dd/8QP+axf9wX/2WgD0D4Jf8kh0L/t4/wDSiSvQK8/+CX/JIdC/7eP/AEokr0CgAooooAKKKKAPn/8Aaa/5lb/t7/8AaNegeEv+SvfEX/uGf+k7V5/+01/zK3/b3/7Rr0Dwl/yV74i/9wz/ANJ2oAPgl/ySHQv+3j/0okrz/wD5u8/z/wA+FegfBL/kkOhf9vH/AKUSV5//AM3ef5/58KAOA+Nv/JXtd/7d/wD0njr3/wAW/wDJXvh1/wBxP/0nWvAPjb/yV7Xf+3f/ANJ469/8W/8AJXvh1/3E/wD0nWgDz/8AZl/5mn/t0/8Aa1H/ADaH/n/n/o/Zl/5mn/t0/wDa1H/Nof8An/n/AKAOA8Jf8kh+Iv8A3DP/AEoau/8A2mv+ZW/7e/8A2jXAeEv+SQ/EX/uGf+lDV3/7TX/Mrf8Ab3/7RoAP+bQ/8/8AP/XAeLf+SQ/Dr/uJ/wDpQtd//wA2h/5/5/64Dxb/AMkh+HX/AHE//ShaAPf/ABb/AMle+HX/AHE//Sda8A+Nv/JXtd/7d/8A0njr3/xb/wAle+HX/cT/APSda8A+Nv8AyV7Xf+3f/wBJ46AD42/8le13/t3/APSeOu//AObQ/wDP/P8A1wHxt/5K9rv/AG7/APpPHXf/APNof+f+f+gD0Dwl/wAle+Iv/cM/9J2rz/8AZl/5mn/t0/8Aa1egeEv+SvfEX/uGf+k7V5/+zL/zNP8A26f+1qAOA+Nv/JXtd/7d/wD0njrv/iB/zWL/ALgv/stcB8bf+Sva7/27/wDpPHXf/ED/AJrF/wBwX/2WgD0D4Jf8kh0L/t4/9KJK9Arz/wCCX/JIdC/7eP8A0okr0CgAooooAKKKKAPn/wDaa/5lb/t7/wDaNegeEv8Akr3xF/7hn/pO1ef/ALTX/Mrf9vf/ALRr0Dwl/wAle+Iv/cM/9J2oAPgl/wAkh0L/ALeP/SiSvP8A/m7z/P8Az4V6B8Ev+SQ6F/28f+lElef/APN3n+f+fCgDgPjb/wAle13/ALd//SeOvf8Axb/yV74df9xP/wBJ1rwD42/8le13/t3/APSeOvf/ABb/AMle+HX/AHE//SdaAPP/ANmX/maf+3T/ANrUf82h/wCf+f8Ao/Zl/wCZp/7dP/a1H/Nof+f+f+gDgPCX/JIfiL/3DP8A0oau/wD2mv8AmVv+3v8A9o1wHhL/AJJD8Rf+4Z/6UNXf/tNf8yt/29/+0aAD/m0P/P8Az/1wHi3/AJJD8Ov+4n/6ULXf/wDNof8An/n/AK4Dxb/ySH4df9xP/wBKFoA9/wDFv/JXvh1/3E//AEnWvAPjb/yV7Xf+3f8A9J469/8AFv8AyV74df8AcT/9J1rwD42/8le13/t3/wDSeOgA+Nv/ACV7Xf8At3/9J467/wD5tD/z/wA/9cB8bf8Akr2u/wDbv/6Tx13/APzaH/n/AJ/6APQPCX/JXviL/wBwz/0navP/ANmX/maf+3T/ANrV6B4S/wCSvfEX/uGf+k7V5/8Asy/8zT/26f8AtagDgPjb/wAle13/ALd//SeOu/8AiB/zWL/uC/8AstcB8bf+Sva7/wBu/wD6Tx13/wAQP+axf9wX/wBloA9A+CX/ACSHQv8At4/9KJK9Arz/AOCX/JIdC/7eP/SiSvQKACiiigAooooA+f8A9pr/AJlb/t7/APaNegeEv+SvfEX/ALhn/pO1FFAB8Ev+SQ6F/wBvH/pRJXn/APzd5/n/AJ8KKKAOA+Nv/JXtd/7d/wD0njr3/wAW/wDJXvh1/wBxP/0nWiigDz/9mX/maf8At0/9rUf82h/5/wCf+iigDgPCX/JIfiL/ANwz/wBKGrv/ANpr/mVv+3v/ANo0UUAH/Nof+f8An/rgPFv/ACSH4df9xP8A9KFoooA9/wDFv/JXvh1/3E//AEnWvAPjb/yV7Xf+3f8A9J46KKAD42/8le13/t3/APSeOu//AObQ/wDP/P8A0UUAegeEv+SvfEX/ALhn/pO1ef8A7Mv/ADNP/bp/7WoooA4D42/8le13/t3/APSeOu/+IH/NYv8AuC/+y0UUAegfBL/kkOhf9vH/AKUSV6BRRQAUUUUAf//Z",
        discount: 12,
        validate: 'upto 56',
        polygon: '/img/polygon.png',
        subprice: '.05'
    }

    const templateValues1 = {
        title: "#TITLE",
        description: "#DESCRIPTION",
        price: "#NEWPRICE",
        oldprice: "#OLDPRICE",
        quantity: '#QUANTITY',
        qrlink: "#QRLINK",
        stock: "#STOCK",
        phone: "#PHONE",
        discount: "#DISCOUNT",
        polygon: "#POLYGONLINK",
        subprice: "#SUBPRICE",
    }
    let head, title, dollar, decimal, price, quantity, des, body, qr, phone, stock, oldprice;

    head = document.getElementById("p-head");
    title = document.getElementById("p-title");
    dollar = document.getElementById("p-$");
    decimal = document.getElementById("p-price-decimal");
    price = document.getElementById("p-new-price");
    quantity = document.getElementById("p-quantity");
    des = document.getElementById("p-description");
    body = document.getElementById(tempSize.info === "2.13 inch" ? "p-body" : "p-card-border");
    qr = document.getElementById("p-qr")
    phone = document.getElementById("p-phoneNo");
    stock = document.getElementById("p-stock");
    oldprice = document.getElementById("p-old-price");
    useEffect(() => {
        if (id) {
            let template = templateData.find(o => o.templateId === id);
            const info = template?.templateInfo.replace('inch', '').trim();
            setPoli(Number(template.fileName) === 1 ? true : false)
            const clsName = imgClasses[info][Number(template.fileName)]
            const size = {
                info: template?.templateInfo,
                fileName: template.fileName,
                imageTemplateId: template.imageTemplateId,
                ...imgClasses[info]["size"]
            }
            setTempSize(size)
            setClassName(clsName)
            setNormal(clsName)
            setState(state => ({ ...state, htmlCode: template?.htmlCode }))
            setValue(value => ({ ...value, isUpdate: true }));
        } else {
            setValue(value => ({ ...value, isUpdate: false }));
            setState(state => ({ ...state, serialNumber: "", screenSize: "", store: "" }))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    useEffect(() => {
        if (state.htmlCode) {
            actionSetHtmlValues()
            price = price ?? document.getElementById("p-new-price")
            des = des ?? document.getElementById("p-description")
            body = body ?? document.getElementById(isPoli ? "p-card-box" : tempSize.info === "2.13 inch" ? "p-body" : "p-card-border")
            const bodyHeight = isPoli ? body.className : body.id === "p-body" ? `c-body body-hight ` : body.id === "p-card-border" ? body.className : "btn-div btn-primarey"
            body.className = bodyHeight
            const pFontSize = price.innerText.length >= 7 ? `${className.newprice} pFontSize` : price.className
            const decimalFontSize = price.innerText.length >= 7 ? `${className.decimal} decimalFontSize` : decimal.className
            price.className = pFontSize
            decimal.className = decimalFontSize
            setClassName({ ...className, newprice: pFontSize, bodyBg: bodyHeight, decimal: decimalFontSize })
            setNormal({ ...normal, newprice: pFontSize, bodyBg: bodyHeight, decimal: decimalFontSize })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.htmlCode])

    const clickedElement = (e) => {
        setFontFamily("select")
        setHtml(e.target.id === "head" ? "p-head" : e.target.id === "body" ? "p-body" : e.target.id === "pcardborder" ? "p-card-border" : e.target.id);
        setSelectID(e.target.id === "head" ? "p-head" : e.target.id === "body" ? "p-body" : e.target.id === "pcardborder" ? "p-card-border" : e.target.id);
    }

    const handleClassName = (name, remove, id) => {
        var ret = name;
        if (remove === "normal" || remove === "bold") {
            remove = remove === "normal" ? "bold" : "normal"
            ret = name.replace(remove, ' ')
        } else if (removeFamily.includes(remove)) {
            const replace = id === "p-title" ? selected.title :
                id === "p-new-price" ? selected.price :
                    id === "p-$" ? selected.doller :
                        id === "p-description" ? selected.description :
                            id === "p-quantity" ? selected.quantity : ""

            ret = name.replace(replace, ' ')
            id === "p-title" ? setFamily({ ...selected, title: remove }) :
                id === "p-new-price" ? setFamily({ ...selected, price: remove }) :
                    id === "p-$" ? setFamily({ ...selected, doller: remove }) :
                        id === "p-description" ? setFamily({ ...selected, description: remove }) :
                            setFamily({ ...selected, quantity: remove })
        }
        const doc = document.getElementById(id);
        doc.className = [...new Set(ret.split(" "))].join(" ");
        return [...new Set(ret.split(" "))].join(" ")
    }
    const handleColorName = (name, remove, id, isBody) => {
        var ret = name;
        if (colors.includes(remove)) {
            ret = name.replace(isBody ? color.bc : color.hc, ' ')
            isBody ? setColor({ ...color, bc: remove }) : setColor({ ...color, hc: remove })
        }

        const doc = document.getElementById(id);
        doc.className = [...new Set(ret.split(" "))].join(" ");

        return [...new Set(ret.split(" "))].join(" ")
    }

    const handleClear = () => {
        head.className = normal.headBg
        body.className = normal.bodyBg
        title.className = normal.title
        dollar.className = normal.dollar
        decimal.className = normal.decimal
        price.className = normal.newprice
        quantity.className = normal.quantity
        des.className = normal.des
        setFontFamily("lato")
        setFamily("lato")
        setColor({ bc: "", hc: "" })
        setClassName(normal)
    }

    const setforPrice = (remove, col) => {
        // if (remove === "red") {
        price.className = className.newprice.replace("cblack", "") + col
        decimal.className = className.decimal.replace("cblack", "") + col
        dollar.className = className.dollar.replace("cblack", "") + col
        title.className = isPoli ? className.title + col : className.title
        // } else if (remove === "white") {
        //     price.className = normal.newprice + " cwhite"
        //     decimal.className = normal.decimal + " cwhite"
        //     dollar.className = normal.dollar + " cwhite"
        //     title.className = isPoli ? normal.title + col : normal.title
        // } else {
        //     price.className = normal.newprice
        //     decimal.className = normal.decimal
        //     dollar.className = normal.dollar
        //     title.className = normal.title
        // }
    }

    const setPrice = (p, q) => {
        price.className = p
        decimal.className = q
    }

    const actionSetHtmlValues = (toApi = false) => {
        if (!isPoli) {
            phone = phone ?? document.getElementById("p-phoneNo");
            phone.innerText = toApi ? "#PHONE" : templateValues2.phone;
            stock = stock ?? document.getElementById("p-stock");
            stock.innerText = toApi ? "#STOCK" : templateValues2.stock;
            quantity = quantity ?? document.getElementById("p-quantity");
            quantity.innerText = toApi ? "#QUANTITY" : templateValues2.quantity;
        } else {
            oldprice = oldprice ?? document.getElementById("p-old-price");
            oldprice.innerText = toApi ? "#OLDPRICE" : templateValues2.oldprice;
            const poli = document.getElementById("p-polygon-img");
            poli.src = toApi ? "#POLYGONLINK" : templateValues2.polygon;
            const dis = document.getElementById("p-discount");
            dis.innerHTML.replace("#DISCOUNT", templateValues2.discount)
            // dis.innerText = dis.innerText
        }
        title = title ?? document.getElementById("p-title");
        title.innerText = toApi ? "#TITLE" : templateValues2.title;
        price = price ?? document.getElementById("p-new-price");
        price.innerText = toApi ? "#NEWPRICE" : templateValues2.newprice;
        des = des ?? document.getElementById("p-description");
        des.innerText = toApi ? "#DESCRIPTION" : templateValues2.description;
        qr = qr ?? document.getElementById("p-qr");
        qr.src = toApi ? "#QRLINK" : templateValues2.qrlink;
        decimal = decimal ?? document.getElementById("p-price-decimal");
        decimal.innerText = toApi ? "#SUBPRICE" : templateValues2.subprice
        return toApi ? document.querySelector(".body-text") : ""
    }

    const actionFontStyle = (e) => {

        const value = e.target.id === "" ? e.target.value : e.target.id
        switch (selectID) {
            case ("p-title"):
                setClassName({ ...className, title: handleClassName(className.title + " " + value, value, selectID) })
                break;
            case ("p-$"):
                setClassName({ ...className, dollar: handleClassName(className.dollar + " " + value, value, selectID) })
                break;
            case ("p-quantity"):
                setClassName({ ...className, quantity: handleClassName(className.quantity + " " + value, value, selectID) })
                break;
            case ("p-description"):
                setClassName({ ...className, des: handleClassName(className.des + " " + value, value, selectID) })
                break;
            case ("p-new-price"):
                const nPrice = handleClassName(className.newprice + " " + value, value, selectID)
                const decimal = handleClassName(className.decimal + " " + value, value, selectID)
                setPrice(nPrice.replace("cwhite", "").replace("cblack", ""), decimal.replace("cwhite", "").replace("cblack", ""))
                setClassName({ ...className, newprice: nPrice, decimal: decimal })
                break;
            case ("p-id"):
                setClassName({ ...className, bg: handleClassName(className.bg + " " + value, value, selectID) })
                break
            case ("p-old-price"):
                setClassName({ ...className, oldprice: handleClassName(className.oldprice + " " + value, value, selectID) })
                break
            case ("p-discount"):
                setClassName({ ...className, discount: handleClassName(className.discount + " " + value, value, selectID) })
                break
            default:
        }
    }
    const actionChangeColor = (e) => {
        const value = e.target.id === "" ? e.target.value : e.target.id
        switch (selectID) {
            case ("p-head"):
                const hbg = handleColorName(className.headBg + " " + value, value, selectID, false)
                setClassName({ ...className, headBg: hbg })
                break
            default:
                const col = value === "white" ? " cwhite" : " cblack"
                const nPrice = handleClassName(`${className.newprice + col}`, col, "p-new-price")
                const decimal = handleClassName(`${className.decimal + col}`, col, "p-price-decimal")
                const doller = handleClassName(`${className.doller + col}`, col, "p-$")
                const bg = handleColorName(className.bodyBg + " " + value, value, selectID, true)
                setClassName({ ...className, bodyBg: bg, doller: doller, newprice: nPrice, decimal: decimal })
                setforPrice(value, col)
                break
        }
    }

    const saveNewTemplate = () => {
        const changedHTML = document.getElementById("template-parent")
        toJpeg(changedHTML, { quality: 1, skipAutoScale: true, pixelRatio: 1, height: tempSize?.height ?? 120, width: tempSize?.width ?? 250 })
            .then((dataUrl) => {
                const html = actionSetHtmlValues(true)
                const url = dataUrl.replace('data:image/jpeg;base64,', '');
                setLoad(true)
                let data = {
                    // awsFileUrl: "string",
                    // createdAt: 0,
                    // createdBy: "string",
                    // creationDate: "2022-12-28T06:11:00.370Z",
                    // customerId: 0,
                    htmlCode: html.outerHTML,
                    templateImage: url,
                    templateImg: url,
                    imageTemplateId: tempSize.imageTemplateId,
                    // templateId: 0,
                    fileName: tempSize.fileName,
                    templateInfo: tempSize.info,
                    noOfProduct: 1
                    // templeImg: {
                    //     "binaryStream": 0
                    // }
                }
                dispatch(getEditedTemplateCode(data)).then(resp => {
                    if (resp.status === 200) {
                        setLoad(false)
                        navigate('/template-library')
                    }
                });
            })
            .catch((err) => {
                console.log("errrrr", err)
            })
    }

    const closeModel = () => {
        setmodel(false)
    }

    return (
        <div>
            {model ? <CustomModal onclose={closeModel} >
                {
                    <div>
                        <p>
                            Are You Sure To Update Template ?
                        </p>
                        <button className='btn btn-primary m-2' onClick={!isLoad ? saveNewTemplate : null}>
                            {isLoad ? <Loader /> : <></>} Yes
                        </button>
                        <button className='btn btn-secondary' onClick={!isLoad ? closeModel : null}>
                            No
                        </button>
                    </div>
                }
            </CustomModal> :
                <></>}
            <div className='d-flex'>

                <div onClick={clickedElement} dangerouslySetInnerHTML={{ __html: state.htmlCode }} />


                <div className='edit-div'>
                    <span className='h5'>{idNames[editData] ? idNames[editData] + ' Selected' : null}</span>
                    <div className='temp-select'>
                        {!isPoli ?
                            <button className='btn-div btn-primary' id="head" onClick={clickedElement}>
                                Select Head
                            </button> :
                            <></>
                        }
                        <button className='mt-2 btn-div btn-primary' id={tempSize.info === "2.13 inch" ? "body" : "pcardborder"} onClick={clickedElement}>
                            Select Body
                        </button>
                    </div>
                    {isBG[editData] ?
                        <div>
                            {removeColor?.map((key) => {
                                return (
                                    <button className={`btn-div btn-${key.btn}`} id={key.class} onClick={actionChangeColor}>
                                        {key.name}
                                    </button>)
                            })}
                        </div> :
                        <div>
                            {fontStyle?.map((key) => {
                                return (
                                    <button className={`btn-div btn-${key.btn}`} id={key.class} onClick={actionFontStyle}>
                                        {key.name}
                                    </button>)
                            })}
                            <Select value={selectID === "p-title" ? selected.title :
                                selectID === "p-new-price" ? selected.price :
                                    selectID === "p-$" ? selected.doller :
                                        selectID === "p-description" ? selected.description :
                                            selected.quantity} options={fontFamily} onchange={actionFontStyle} />
                        </div>
                    }
                </div>
            </div>
            <div className='b-btn-div'>
                <button className={`btn btn-warning float-left`} onClick={handleClear}>
                    Clear
                </button>
                <button className='btn btn-primary float-right' onClick={() => setmodel(true)}>Save as New Template</button>
            </div>

        </div>
    )
}
